/**
 * Voice media follows the same rule as Space text: an e2ee Space encrypts
 * everything, even when a channel has no stored `cipherCheck`.
 */

export function voiceChannelNeedsMediaE2ee(params: {
  spaceId: string;
  activeSpace?: { id: string; e2ee?: boolean } | null;
  spaces?: readonly { id: string; e2ee?: boolean }[];
  channel?: { cipherCheck?: unknown } | null;
}): boolean {
  if (params.channel?.cipherCheck) return true;
  if (params.activeSpace?.id === params.spaceId) return !!params.activeSpace.e2ee;
  return !!params.spaces?.some((space) => space.id === params.spaceId && space.e2ee);
}
